import { Dropdown } from '@net0-calc/common/components';
import { CalculatorFormValues, TripPurpose } from 'common/types';
import { FC, useMemo } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { EventNameInput } from './EventNameInput';
import { useTranslation } from 'react-i18next';

interface TripPurposeFieldsProps {
  values?: Pick<CalculatorFormValues, 'tripPurpose'>;
}

export const TripPurposeFields: FC<TripPurposeFieldsProps> = ({ values }) => {
  const { t } = useTranslation();

  const tripPurposeOptions = useMemo(
    () => [
      { title: t('personal.pages.tripDuration.form.field.tripPurpose.leisure'), value: TripPurpose.LEISURE },
      { title: t('personal.pages.tripDuration.form.field.tripPurpose.event'), value: TripPurpose.EVENT },
      { title: t('personal.pages.tripDuration.form.field.tripPurpose.business'), value: TripPurpose.BUSINESS },
    ],
    [t],
  );

  return (
    <>
      <Field name="tripPurpose">
        {({ input }: FieldRenderProps<any>) => (
          <Dropdown
            {...input}
            label={t('personal.pages.tripDuration.form.field.tripPurpose.label')}
            options={tripPurposeOptions}
          />
        )}
      </Field>
      {values?.tripPurpose === TripPurpose.EVENT && <EventNameInput />}
    </>
  );
};
